import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { AlertTriangle, User, IdCard, Phone, MapPin, Save } from 'lucide-react';

const QuickEditDialog = ({
  open,
  onOpenChange,
  customer,
  form,
  setForm,
  onSave,
  saving,
  getMissingFields,
}) => {
  if (!customer) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="quick-edit-dialog" aria-describedby="quick-edit-dialog-desc">
        <DialogHeader>
          <DialogTitle className="text-xl flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Completar Datos del Cliente
          </DialogTitle>
          <p id="quick-edit-dialog-desc" className="text-sm text-gray-500">
            {customer?.nombre_completo || 'Cliente'} - Completa la informacion faltante
          </p>
        </DialogHeader>
        <div className="space-y-3 pt-2">
          {getMissingFields(customer).length > 0 && (
            <div className="p-3 bg-amber-50 border border-amber-300 rounded-lg">
              <p className="text-amber-800 text-sm font-medium flex items-center gap-1">
                <AlertTriangle className="h-4 w-4" />
                Campos faltantes: {getMissingFields(customer).map(f => f.label).join(', ')}
              </p>
            </div>
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <Label className="text-sm font-semibold flex items-center gap-1"><User className="h-3 w-3" /> Nombre</Label>
              <Input data-testid="quick-edit-nombre" value={form.nombre_completo} onChange={(e) => setForm(p => ({ ...p, nombre_completo: e.target.value }))} className={`h-10 mt-1 ${!customer.nombre_completo ? 'border-amber-400 bg-amber-50' : ''}`} />
            </div>
            <div>
              <Label className="text-sm font-semibold flex items-center gap-1"><IdCard className="h-3 w-3" /> Cedula/ID</Label>
              <Input data-testid="quick-edit-cedula" value={form.cedula_pasaporte} onChange={(e) => setForm(p => ({ ...p, cedula_pasaporte: e.target.value }))} className={`h-10 mt-1 ${!customer.cedula_pasaporte ? 'border-amber-400 bg-amber-50' : ''}`} />
            </div>
            <div>
              <Label className="text-sm font-semibold flex items-center gap-1"><Phone className="h-3 w-3" /> Telefono</Label>
              <Input data-testid="quick-edit-telefono" value={form.telefono} onChange={(e) => setForm(p => ({ ...p, telefono: e.target.value }))} className={`h-10 mt-1 ${!customer.telefono ? 'border-amber-400 bg-amber-50' : ''}`} />
            </div>
            <div>
              <Label className="text-sm font-semibold flex items-center gap-1"><Phone className="h-3 w-3" /> Tel. Alternativo</Label>
              <Input data-testid="quick-edit-tel-alt" value={form.telefono_alternativo} onChange={(e) => setForm(p => ({ ...p, telefono_alternativo: e.target.value }))} className="h-10 mt-1" />
            </div>
            <div className="sm:col-span-2">
              <Label className="text-sm font-semibold flex items-center gap-1"><MapPin className="h-3 w-3" /> Direccion</Label>
              <Input data-testid="quick-edit-direccion" value={form.direccion_completa} onChange={(e) => setForm(p => ({ ...p, direccion_completa: e.target.value }))} className={`h-10 mt-1 ${!customer.direccion_completa ? 'border-amber-400 bg-amber-50' : ''}`} />
            </div>
            <div className="sm:col-span-2">
              <Label className="text-sm font-semibold flex items-center gap-1"><MapPin className="h-3 w-3" /> Apartamento</Label>
              <Input data-testid="quick-edit-apartamento" value={form.apartamento} onChange={(e) => setForm(p => ({ ...p, apartamento: e.target.value }))} placeholder="Ej: Apt 4B, Piso 2" className="h-10 mt-1" />
            </div>
            <div>
              <Label className="text-sm font-semibold">Ciudad</Label>
              <Input data-testid="quick-edit-ciudad" value={form.ciudad} onChange={(e) => setForm(p => ({ ...p, ciudad: e.target.value }))} className="h-10 mt-1" />
            </div>
            <div>
              <Label className="text-sm font-semibold">Provincia</Label>
              <Input data-testid="quick-edit-provincia" value={form.provincia} onChange={(e) => setForm(p => ({ ...p, provincia: e.target.value }))} className="h-10 mt-1" />
            </div>
          </div>
          <Button data-testid="quick-edit-save-btn" onClick={onSave} disabled={saving} className="w-full h-11 bg-amber-500 hover:bg-amber-600">
            <Save className="mr-2 h-4 w-4" />
            {saving ? 'Guardando...' : 'Guardar Datos'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default QuickEditDialog;
